import { State } from '../state';

export const dashboard: State = {
    url: 'dashboard'
};
